import React from "react"

type Props = {} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>

export const Divider = ({ className, ...rest }: Props) => {
  return (
    <div
      className={`${className ? className : ""} block h-[1px] min-w-full`}
      {...rest}
    />
  )
}
